import {
  IReadMyOrder,
  IReadMyOrderNodePayload,
} from "../types/easy-e-m-i-loan-journey-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export const readMyOrderNode = async (
  payload: IReadMyOrderNodePayload
): Promise<IResponse<IReadMyOrder>> => {
  const response = await encryptedRequest<IReadMyOrder>({
    method: "POST",
    url: `${API_PATHS.readMyOrder}`,
    data: payload,
  });
  return response;
};
